import { saveToStorage, getFromStorage } from '../../../used-vue/api/Storage';

const state = {
    valuations: [],
    selectedValuation: false,
    initialized: false,
};

const actions = {
    initialize({ commit, state }) {
        if (state.initialized) {
            return;
        }
        commit('loadFromStorage');
        commit('setInitialized', true);
    },
    deleteValuation({ commit, state }, valuationToDelete) {
        let newValuationArray = [];
        for (let index = 0, len = state.valuations.length; index < len; index++) {
            if (state.valuations[index].valuation != valuationToDelete.valuation
                || state.valuations[index].reg_no != valuationToDelete.reg_no
                || state.valuations[index].mileage != valuationToDelete.mileage
                || state.valuations[index].valid_on != valuationToDelete.valid_on
            ) {
                newValuationArray.push(JSON.parse(JSON.stringify(state.valuations[index])));
            }
        }

        state.valuations = newValuationArray;
        commit('saveToStorage');
    }
};

const getters = {};

const mutations = {
    setInitialized(state, newState) {
        state.initialized = newState;
    },
    loadFromStorage(state) {
        try {
            state.valuations = JSON.parse(getFromStorage('valuations', '[]'));
        } catch (error) {
            console.error('Vuex Valuations module@loadFromStorage failed to parse valuations from Storage');
            state.valuations = [];
        }
    },
    saveToStorage(state) {
        try {
            saveToStorage('valuations', JSON.stringify(state.valuations));
        } catch (error) {
            console.error("Vuex commit('Valuations\saveToStorage': Error storing valuations", error);
        }
    },
    addValuation(state, valuation) {
        state.valuations.push(valuation);
    },
    clearValuation(state) {
        state.selectedValuation = false;
    },
    selectValuation(state, valuationToSelect) {
        let foundValuation = false;
        for (let index = 0, len = state.valuations.length; index < len; index++) {
            if (state.valuations[index].valuation == valuationToSelect.valuation
                && state.valuations[index].reg_no == valuationToSelect.reg_no
                && state.valuations[index].mileage == valuationToSelect.mileage
                && state.valuations[index].valid_on == valuationToSelect.valid_on
            ) {
                state.selectedValuation = state.valuations[index];
                foundValuation = true;
            }
        }

        if (!foundValuation) {
            state.selectedValuation = false;
        }
    },
};

export default {
    namespaced: true,
    state,
    getters,
    actions,
    mutations
};